module.exports = __webpack_public_path__ + "img/visa.98edc46d.png";